import {
  Card,
  CardContent,
  CardHeader,
  Fab,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useFieldArray, useFormContext } from "react-hook-form";
import { PorukaGreskePolja, TipElektronickeAdrese } from "../../../index";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";

const Index = ({
  nazivOdjeljka,
  naslov,
}: {
  nazivOdjeljka: string;
  naslov?: string;
}) => {
  const { register } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    name: nazivOdjeljka,
  });
  const dodaj = () => {
    append({
      tip: { id: undefined },
      adresa: "",
    });
  };

  const ukloni = (index: number) => {
    remove(index);
  };

  return (
    <>
      <Card
        variant={"outlined"}
        sx={{ mt: 3, position: "relative" }}
        className={fields.length <= 0 ? "root-p-0" : ""}
      >
        <CardHeader
          title={naslov || "Ostale elektroničke adrese (Other electronic addresses)"}
          titleTypographyProps={{ variant: "h6" }}
          action={
            <>
              <Tooltip title={"Dodaj (Add)"}>
                <Fab
                  size={"small"}
                  aria-label="settings"
                  onClick={dodaj}
                  disabled={fields.length >= 10}
                >
                  <AddIcon />
                </Fab>
              </Tooltip>
            </>
          }
        ></CardHeader>
        <CardContent>
          {fields.map((field: any, index) => (
            <Card variant={"outlined"} sx={{ mt: 3, position: "relative" }}>
              <CardHeader
                title={`Elektronička adresa (Electronic address) ${index + 1}`}
                titleTypographyProps={{ variant: "h6" }}
                action={
                  <>
                    <Tooltip title={"Ukloni (Remove)"}>
                      <IconButton
                        aria-label="settings"
                        onClick={() => ukloni(index)}
                      >
                        <RemoveIcon />
                      </IconButton>
                    </Tooltip>
                  </>
                }
              ></CardHeader>
              <CardContent>
                <Grid container spacing={2} key={field.id}>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      error={
                        !daLiJePoljeValidno(`${nazivOdjeljka}[${index}].adresa`)
                      }
                    >
                      <InputLabel htmlFor={nazivOdjeljka}>
                        Elektronička adresa (Electronic address)
                      </InputLabel>
                      <Input
                        aria-describedby="elektronicka adresa"
                        {...register(`${nazivOdjeljka}[${index}].adresa`)}
                      />
                    </FormControl>
                    <PorukaGreskePolja
                      nazivPolja={`${nazivOdjeljka}[${index}].adresa`}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TipElektronickeAdrese
                      nazivPolja={`${nazivOdjeljka}[${index}].tip`}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          ))}
          <PorukaGreskePolja
            nazivPolja={"operaterPlatforme.elektronickeAdrese"}
          />
        </CardContent>
      </Card>
    </>
  );
};

export default Index;
